import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

export const UnstyledHeading = ({ level, ...props }) => {
  const H = `h${level || 2}`;
  return <H {...props} />;
};

UnstyledHeading.propTypes = {
  level: PropTypes.number,
};

const HeadingStyle = styled(UnstyledHeading).attrs(
  ({
    $margin,
    $fontSize,
    $color,
    $backgroundColor,
    $textAlign,
    $textTransform,
  }) => ({
    $margin: $margin || "",
    $fontSize: $fontSize || undefined,
    $color: $color || "",
    $backgroundColor: $backgroundColor || "",
    $textAlign: $textAlign || "",
    $textTransform: $textTransform || "",
  })
)`
  margin: ${({ $margin }) => $margin};
  font-size: ${({ $fontSize }) => $fontSize};
  color: ${({ $color }) => $color};
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  text-align: ${({ $textAlign }) => $textAlign};
  text-transform: ${({ $textTransform }) => $textTransform};
`;

const Heading = ({
  level,
  anchor,
  className,
  margin,
  fontSize,
  color,
  backgroundColor,
  textAlign,
  content,
  textTransform,
}) => {
  return (
    <HeadingStyle
      level={level}
      {...(anchor ? { id: anchor } : {})}
      className={className}
      $margin={margin}
      $fontSize={fontSize}
      $color={color}
      $backgroundColor={backgroundColor}
      $textAlign={textAlign}
      $textTransform={textTransform}
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
};

Heading.propTypes = {
  anchor: PropTypes.string,
  className: PropTypes.string,
  margin: PropTypes.string,
  fontSize: PropTypes.string,
  color: PropTypes.string,
  backgroundColor: PropTypes.string,
  textAlign: PropTypes.string,
  content: PropTypes.string,
  textTransform: PropTypes.string,
  level: PropTypes.number,
};

export default Heading;
